import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Check, X, ShieldCheck, FileText } from "lucide-react";
import { api, API } from "@/lib/api";
import { useApp } from "@/store";

export default function AdminKyc() {
  const { user } = useApp();
  const [pending, setPending] = useState([]);

  const load = () => api.get("/admin/kyc/pending").then(({ data }) => setPending(data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const decide = async (id, decision) => {
    try { await api.post(`/admin/kyc/${id}/${decision}`); toast.success(`Marked as ${decision}`); load(); }
    catch { toast.error("Action failed"); }
  };

  if (user && user.role !== "admin") return <div className="py-24 text-center text-gray-400">Admins only.</div>;

  return (
    <div className="mx-auto max-w-4xl px-5 py-12 sm:px-8">
      <h1 className="flex items-center gap-2 font-display text-3xl font-extrabold tracking-tight"><ShieldCheck className="text-[#002FA7]" /> KYC Review Queue</h1>
      <p className="mt-2 text-gray-500">Documents pending compliance approval.</p>
      <div className="mt-8 space-y-3" data-testid="kyc-queue">
        {pending.length === 0 ? (
          <p className="text-gray-400" data-testid="kyc-queue-empty">No documents pending approval.</p>
        ) : pending.map((u) => (
          <div key={u.user_id} className="flex flex-wrap items-center justify-between gap-4 rounded-2xl border border-gray-200 p-5" data-testid={`kyc-item-${u.user_id}`}>
            <div>
              <div className="font-bold">{u.name} <span className="text-xs font-normal text-gray-400">· {u.email}</span></div>
              <div className="text-xs uppercase tracking-widest text-gray-400">{u.person_type} · {u.country} · {u.data_region}</div>
              {u.kyc_document && (
                <a href={`${API}/files/${u.kyc_document.storage_path}`} target="_blank" rel="noreferrer"
                  className="mt-1 inline-flex items-center gap-1 text-sm font-semibold text-[#002FA7] hover:underline">
                  <FileText size={14} /> {u.kyc_document.original_filename}
                </a>
              )}
            </div>
            <div className="flex gap-2">
              <button data-testid={`approve-${u.user_id}`} onClick={() => decide(u.user_id, "approved")} className="inline-flex items-center gap-1 rounded-full bg-[#155724] px-4 py-2 text-sm font-bold text-white transition-colors hover:opacity-90"><Check size={15} /> Approve</button>
              <button data-testid={`reject-${u.user_id}`} onClick={() => decide(u.user_id, "rejected")} className="inline-flex items-center gap-1 rounded-full bg-[#FF3B30] px-4 py-2 text-sm font-bold text-white transition-colors hover:bg-[#E6352B]"><X size={15} /> Reject</button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
